import { useContext, useRef } from 'react'

import { Typography } from '@material-ui/core'
import Editor from '@scoir/editor'

import ContentModalContext from '../../../ContentModalProvider/Context'
import ValidationMessage from '../../../components/ValidationMessage'
import { ERROR_MESSAGES, FIELD_NAMES, LABELS } from '../../../components/constants'

const label = LABELS.DESCRIPTION

const Description = () => {
  const { item, onUpdateField } = useContext(ContentModalContext)
  const value = item[FIELD_NAMES.DESCRIPTION]
  const touchedRef = useRef(false)
  const touched = touchedRef.current
  return (
    <>
      <Typography variant="subtitle2">{`${label}*`}</Typography>
      <div>
        <Editor
          value={value}
          onChange={(html: string) => {
            touchedRef.current = true
            onUpdateField(FIELD_NAMES.DESCRIPTION, html)
          }}
        />

        <ValidationMessage
          label={label}
          touched={touched}
          valuesByError={{
            [ERROR_MESSAGES.REQUIRED]: value,
          }}
        />
      </div>
    </>
  )
}

export default Description
